import { TableCell, Tooltip, TooltipContent, TooltipTrigger } from "@dune/ui";

interface TableCellWithTooltipProps extends React.ComponentProps<"td"> {
	children: React.ReactNode;
	tooltipContent?: React.ReactNode;
}

export const TableCellWithTooltip = ({
	children,
	tooltipContent,
	...props
}: TableCellWithTooltipProps) => {
	const content = <div className="truncate">{children}</div>;

	return (
		<TableCell {...props}>
			{tooltipContent ? (
				<Tooltip>
					<TooltipTrigger asChild>{content}</TooltipTrigger>
					<TooltipContent align="start">{tooltipContent}</TooltipContent>
				</Tooltip>
			) : (
				content
			)}
		</TableCell>
	);
};
